import { styled } from '@mui/system'
import Typography from '../../../atoms/typography'
import Button from '../../../molecules/button'
import Dialog from '../../../molecules/dialog'

const DialogStyled = styled(Dialog)`
	.MuiPaper-root {
		padding-bottom: 66px;
	}
`

const AdditionalText = styled(Typography)`
	${({ theme }) => theme.breakpoints.up('md')} {
		max-width: 60%;
	}
`
const ButtonStyled = styled(Button)`
	font-weight: normal;
`

export { DialogStyled, AdditionalText, ButtonStyled }
